<template>
	<div
		class="tabs"
		:class="{ 'tabs--border': border }"
		role="tablist"
		:aria-label="ariaLabel"
	>
		<slot></slot>
	</div>
</template>

<script>
/**
Wraps tabs:
 - determines which tab is active
 - provides border style control
 - accessiblity props
*/
export default {
	name: 'Tabs',
	props: {
		active: {
			type: String,
			default: null,
		},
		ariaLabel: {
			type: String,
			default: 'Tabs',
		},
		border: {
			type: Boolean,
			default: true,
		},
	},
	model: {
		prop: 'active',
		event: 'change',
	},
	methods: {
		selected(event) {
			this.$emit('change', event);
		},
	},
};
</script>

<style lang="scss" scoped>
.tabs {
	&--border {
		border-bottom: $b360-border-width-thin solid $border-color-light;
	}
}
</style>
